module.exports = __webpack_public_path__ + "static/media/Default_profile.43a11d67.jpg";